import React from "react";

export default function PageHeader({ title, subtitle, actions, logo }) {
  return (
    <div className="flex items-end justify-between border-b border-zinc-200 bg-white px-6 py-4 sticky top-0 z-10">
      <div className="flex items-center gap-4">
        {logo && <img src={logo} alt="BY BONE" className="h-12 w-auto object-contain" data-testid="header-logo" />}
        <div>
          <h1 className="font-head font-black text-2xl tracking-tight text-zinc-900">{title}</h1>
          {subtitle && <p className="text-sm text-zinc-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}
